export default __webpack_public_path__ + "static/media/GreyRecommendation.67b4564d.svg";